import { useTranslation } from 'next-i18next'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { selectImageModal, setImageModalOpenActionCreator } from '~/redux/slices/chat-ai'
import Button from '~/components/Buttons/Button'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import CloseButtonIcon from '~/components/Icons/svgs/CloseButtonIcon'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const ChatAiImageModal = (): React.ReactElement => {
  const dispatch = useAppDispatch()
  const imageModal = useAppSelector(selectImageModal)
  const { t } = useTranslation('chatAi')

  const onClose = (): void => {
    dispatch(setImageModalOpenActionCreator({ isImageModalOpen: false, image: '' }))
  }

  if (!imageModal.isImageModalOpen) return <></>

  return (
    <article className="z-oracle-image fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center">
      <div className=" absolute right-0 top-0">
        <Button onClick={onClose}>
          <SVGIcon icon={CloseButtonIcon} pathClassName="text-white" size={20} />
        </Button>
      </div>
      <ResponsiveImage
        alt={t('oracleImageAlt')}
        className="max-w-full max-h-full"
        imageClassName="max-w-full max-h-full object-contain"
        src={imageModal.image}
      />
    </article>
  )
}

export default ChatAiImageModal
